import React from 'react';
import Plan from '../../components/plan/PlanDevContainer';
// import ReactMapGL from 'react-map-gl';

export default function PlanPage() {
  const [viewport, setViewport] = React.useState({
    latitude: 37.7577,
    longitude: -122.4376,
    zoom: 8
  });
  
  React.useEffect(() => {
    document.title = "Shems Almadina - Plan"
    return () => {
      document.title = "Shems Almadina"
    };
  }, []);

  return (
    <Plan />
    // <ReactMapGL
    //   {...viewport}
    //   width="100%"
    //   height="100%"
    //   onViewportChange={(viewport) => setViewport(viewport)}
    // />
  );
}